import { Check } from 'lucide-react';
import videCallImage from '../../assets/pexels-thirdman-5060979.jpg';
import SectionLayout from '../../layouts/SectionLayout';

const AboutSection = () => {
  return (
    <SectionLayout
      id='about'
      titleFirstPart='What'
      titleSecondPart='We Do'
      additionalClassNames='bg-legal-bg-brown pb-20'
      isFullWidth
    >
      <div className='w-[95%] max-w-[1800px] lg:w-[90%] xl:w-4/5 mx-auto flex flex-col md:flex-row items-center justify-between mt-10 gap-10'>
        <div className='relative flex items-center justify-center flex-1'>
          <div className='relative w-full md:w-[300px] lg:w-[450px] h-[400px] lg:h-[550px] rounded-tl-3xl rounded-br-3xl overflow-hidden border-2 border-legal-brown'>
            <img
              className='size-full object-cover'
              src={videCallImage}
              alt='video call'
            />
            <div className='absolute inset-0 size-full bg-legal-dark-blue/30' />
          </div>
        </div>

        <div className='md:w-1/2 space-y-6 text-center md:text-left'>
          <h3 className=' text-3xl md:text-4xl lg:text-5xl font-semibold text-legal-dark-gray capitalize'>
            <span>Empowering Legal Access</span>
            <br />
            <span className='text-legal-brown italic leading-[1.15]'>
              For Everyone
            </span>
          </h3>

          <div className='space-y-4'>
            <p className='text-xl font-marcellus'>
              We bridge the gap between clients and legal professionals, making
              expert legal advice accessible, convenient, and secure.
            </p>

            <p className='text-xl font-marcellus'>
              By breaking down traditional complexities, we ensure expert
              guidance is always just a click—away. Our user-centric platforms
              prioritize security and simplicity, redefining ease in legal
              support. Our commitment to clarity and affordability ensures
              quality legal assistance is no longer a privilege but a right for
              all.
            </p>
          </div>

          <div className='flex flex-col items-center md:items-start gap-3'>
            <div className='flex items-center gap-1'>
              <span>
                <Check className='text-legal-brown size-6'></Check>
              </span>
              <span className='text-lg font-marcellus '>24/7 Support</span>
            </div>
            <div className='flex items-center gap-1'>
              <span>
                <Check className='text-legal-brown size-6'></Check>
              </span>
              <span className='text-lg font-marcellus'>Secure Platform</span>
            </div>
            <div className='flex items-center gap-1'>
              <span>
                <Check className='text-legal-brown size-6'></Check>
              </span>
              <span className='text-lg font-marcellus'>Affordable</span>
            </div>
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};

export default AboutSection;
